import { useScreen } from '../useScreen';

interface ViewProps {
    onContinue: () => void;
}

const usePickUpConfirmed = (): ViewProps => {
    const { onContinue, onHome, continueEnabled } = useScreen();

    return {
        onContinue: continueEnabled ? onContinue : onHome
    };
};

export default usePickUpConfirmed;
